<div class="container p-4">
    <div class="row d-flex justify-content-center mb-4">
        <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
        <div class="col-12 text-center modal-title">{{'INCIDENT_INFO.DETAILS' | translate}}</div>
    </div>
    <section id="dfSection" *ngIf="(formData$ | async)! as dataForm">
        <app-dynamic-form [formName]="'infoIncidentForm'" [formData]="dataForm" [disabled]="false" #dynamicForm></app-dynamic-form>
        <img *ngIf="dataForm.fields[2].value as base64" [src]="'data:image/png;base64,'+base64" width="100%" alt="Base64" />
    </section>
</div>